import React from 'react';
import Typography from '@mui/material/Typography';
import { getTranslation } from '../../../../utils/translations';
import List from '../../../../uikit/special/List';
import translations from './translations';
import { Container, Row, Col } from '../../../../uikit/grid';
import useEmotionStyles from '../../../../uikit/hooks/useEmotionStyles';
var t = getTranslation(translations);
var styles = function (theme) {
    var _a;
    return ({
        wrapper: (_a = {
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
                marginBottom: theme.spacing(3),
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            },
            _a[theme.breakpoints.up('lg')] = {
                height: '254px',
                backgroundImage: "url('/financeAdsHeader_desktop.png')",
            },
            _a[theme.breakpoints.down('lg')] = {
                height: '220px',
                backgroundImage: "url('/financeAdsHeader_mobile.png')",
            },
            _a),
        title: {
            padding: "".concat(theme.spacing(2), " 0"),
            lineHeight: '2.3rem',
            fontWeight: 700,
            color: '#FFF',
        },
    });
};
var listOptions = [t.point_1, t.point_2, t.point_3];
export default function FinanceAdsHeader() {
    var cs = useEmotionStyles(styles);
    return (React.createElement("div", { className: cs.wrapper },
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, { sm: 12 },
                    React.createElement(Typography, { variant: 'h1', className: cs.title }, t.title),
                    React.createElement(List, { white: true, items: listOptions }))))));
}
